export const PaymentMethodDisplayOptions: { [key: string]: string } = {
    'direct deposit': 'paymentMethod.directDeposit',
    cheque: 'paymentMethod.cheque',
    other: 'paymentMethod.other',
};
